import * as THREE from 'THREE';

const rawMaterials = require('data/materials.json');

const rawMaterialDict = {};
const materialDict = {};

function createEnvMap() {
  const path = 'static/images/envmap/';
  const format = '.png';
  const urls = [
    `${path}right${format}`, `${path}left${format}`,
    `${path}up${format}`, `${path}down${format}`,
    `${path}front${format}`, `${path}back${format}`
  ];

  const reflectionCube = new THREE.CubeTextureLoader().load(urls);
  reflectionCube.format = THREE.RGBFormat;

  return reflectionCube;
}

const envMap = createEnvMap();

function createUniforms(rawUniforms) {
  const uniforms = {};
  const inheritShaderName = rawUniforms.inheritFrom || 'lambert';
  const inheritUniforms = THREE.UniformsUtils.clone(
    THREE.ShaderLib[inheritShaderName].uniforms);

  Object.keys(rawUniforms).forEach((uniformName) => {
    const rawUniform = rawUniforms[uniformName];
    let texture;

    if (uniformName === 'inheritFrom') {
      return;
    }

    switch (rawUniform.type) {
      case 't':
        texture = THREE.ImageUtils.loadTexture(rawUniform.value);
        texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
        texture.anisotropy = 16;
        uniforms[uniformName] = {
          type: rawUniform.type,
          value: texture
        };
        break;
      case 'f':
        uniforms[uniformName] = Object.assign({}, rawUniform);
        break;
      case 'v3':
        uniforms[uniformName] = {
          type: rawUniform.type,
          value: new THREE.Vector3(
            rawUniform.value.x, rawUniform.value.y, rawUniform.value.z)
        };
        break;
      case 'c':
        uniforms[uniformName] = {
          type: rawUniform.type,
          value: new THREE.Color(parseInt(rawUniform.value, 16))
        };
        break;
      default:
        console.warn(`unsupported uniform type ${rawUniform.type}`);
        break;
    }
  });

  return Object.assign(inheritUniforms, uniforms);
}

function overrideObjectProperty(obj1, obj2) {
  Object.keys(obj2).forEach((key) => {
    const value = obj2[key];

    if (value instanceof Object) {
      if (Array.isArray(value) || value == null) {
        obj1[key] = value;
      } else {
        overrideObjectProperty(obj1[key], value);
      }
    } else {
      obj1[key] = value;
    }
  });
}

function createInheritRawMaterial(rawMaterial) {
  const newMaterial =
    JSON.parse(JSON.stringify(rawMaterialDict[rawMaterial.inheritFrom]));
  rawMaterial = JSON.parse(JSON.stringify(rawMaterial));
  overrideObjectProperty(newMaterial, rawMaterial);
  newMaterial.inheritFrom = null;
  return newMaterial;
}

function createMaterial(rawMaterial) {
  const materialObj = {};
  let material;

  if (rawMaterial.inheritFrom) {
    rawMaterial = createInheritRawMaterial(rawMaterial);
  }

  if (rawMaterial.type === 'lambert') {
    material = new THREE.MeshLambertMaterial();
    material.color = new THREE.Color(parseInt(rawMaterial.color, 16));
  } else if (rawMaterial.type === 'shader') {
    const uniforms = createUniforms(rawMaterial.uniforms);

    /* eslint-disable */
    material = new THREE.ShaderMaterial({
      uniforms: uniforms,
      vertexShader: require('shaders/' + rawMaterial.shader_id + '.vs'),
      fragmentShader: require('shaders/' + rawMaterial.shader_id + '.fs'),
      derivatives: true,
      lights: true
    });
    /* eslint-enable */

    if (rawMaterial.uniforms.inheritFrom === 'standard') {
      if (uniforms.roughnessMap) {
        material.roughnessMap = uniforms.roughnessMap.value;
      }
      material.envMap = envMap;
    }
  } else {
    material = new THREE.MeshPhongMaterial();

    if (rawMaterial.emissive) {
      material.emissive = new THREE.Color(parseInt(rawMaterial.emissive, 16));
    }
    if (rawMaterial.specular) {
      material.specular = new THREE.Color(parseInt(rawMaterial.specular, 16));
    }
    if (rawMaterial.shininess) {
      material.shininess = rawMaterial.shininess;
    }
    if (rawMaterial.reflective) {
      material.envMap = envMap;
    }

    material.color = new THREE.Color(parseInt(rawMaterial.color, 16));
  }

  material.shading = THREE.SmoothShading;

  materialObj.id = rawMaterial.id;
  materialObj.name = rawMaterial.name;
  materialObj.material = material;

  return materialObj;
}

rawMaterials.forEach((rawMaterial) => {
  rawMaterialDict[rawMaterial.id] = rawMaterial;
});

export default {
  getMaterialData: function getMaterialData(id) {
    let material = materialDict[id];
    if (!material) {
      material = materialDict[id] = createMaterial(rawMaterialDict[id]);
    }
    return material;
  }
};



// WEBPACK FOOTER //
// ./src/services/material-database.js